import { render, staticRenderFns } from "./my-tag.vue?vue&type=template&id=ddeb6188&scoped=true&"
import script from "./my-tag.vue?vue&type=script&lang=js&"
export * from "./my-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeb6188",
  null
  
)

export default component.exports